// 机构合作页面
import { beforeEnterResearchMode } from './researchMode';
import { beforeEnterOpenChatHome } from '@/pages/aiAssistant/utils/openChatModeRestore';

export default {
  meta: {
    localeModules: [
      'roadshow',
      'summary',
      'question',
      'aiChat',
      'aiAssistant',
      'researchEditor',
      'aiChatConstants',
      'aiTools',
      'openClaw',
      'cloudDocument',
      'report',
      'daily',
      'schedule'
    ]
  },
  // 机构合作页面
  path: '/thirdparty',
  redirect: '/thirdparty/not-found',
  component: () => import(/* webpackChunkName: 'main-router-view' */ './routerView.vue'),
  children: [
    // 机构合作路演页面
    {
      path: 'roadshow',
      name: 'instituteRoadshow',
      component: () => import(/* webpackChunkName: 'thirdparty-roadshow-list' */ '@/thirdparty/view/roadshow/list.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    // irm 纪要详情页面
    {
      path: 'aiSummaryDetail',
      name: 'aiInstituteSummaryDetail',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-ai-summary-detail' */ '@/thirdparty/view/roadshow/aiSummaryDetail.vue'),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/summary'
      }
    },
    // 路演直播厅
    {
      path: 'roadshowDetail',
      name: 'instituteRoadshowDetail',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-roadshow-detail' */ '@/thirdparty/view/roadshow/detail.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    // 纪要列表页面
    {
      path: 'summary',
      name: 'instituteSummary',
      component: () => import(/* webpackChunkName: 'thirdparty-summary-index' */ '@/thirdparty/view/summary/index.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    // 纪要详情页面
    {
      path: 'summaryDetail',
      name: 'instituteSummaryDetail',
      component: () =>
        import(
          /* webpackChunkName: 'thirdparty-summary-detail' */ '@/pages/scheduleManage/mine/roadshowMeetingPage.vue'
        ),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/summary'
      }
    },
    // 问答列表页
    {
      path: 'question',
      name: 'instituteQuestion',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-question-index' */ '@/thirdparty/view/question/index.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    // IRM 嵌套：日报详情（与 /market/daily-detail 同组件；完整 path：/thirdparty/market/daily-detail）
    {
      path: 'market/daily-detail',
      name: 'thirdpartyMarketDailyDetail',
      component: () => import(/* webpackChunkName: 'thirdparty-daily-detail' */ '@/thirdparty/view/daily/index.vue'),
      meta: {
        name: 'routers.find_daily_detail',
        pageLevel: 1,
        keepAlive: false,
        hideBreadcrumb: true,
        hideSidebarMenu: true,
        hideAgentModule: true,
        hideOuterBreadcrumb: true,
        hiddenNav: true,
        thirdPartyPage: true
      }
    },
    // 综合页面
    {
      path: 'main/:id?/:rest*',
      name: 'instituteMain',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-main-index' */ '@/thirdparty/view/comprehensive/index.vue'),
      meta: {
        keepAlive: true, // 此页面需要缓存
        thirdPartyPage: true
      }
    },
    // 调研详情页
    {
      path: 'activity/:id',
      name: 'instituteResearchActivity',
      props: true,
      component: () =>
        import(/* webpackChunkName: 'thirdparty-research-activity' */ '@/pages/research/activity/detail.vue'),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/main'
      }
    },
    // 研报详情页
    {
      // 全局搜索的研报详情页面
      path: 'reportDetail',
      name: 'instituteReportDetail',
      component: () => import(/* webpackChunkName: 'thirdparty-report-detail' */ '@/pages/reportManage/preview/index'),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/main'
      }
    },
    // 点评详情页（供中转页 / 模型组链接跳转）
    {
      path: 'commentDetail/:id',
      name: 'instituteCommentDetail',
      component: () => import(/* webpackChunkName: 'thirdparty-comment-detail' */ '@/pages/comment/detail/index.vue'),
      meta: {
        localeModules: ['comment', 'member'],
        thirdPartyPage: true,
        parent: '/thirdparty/main'
      }
    },
    // 全局搜索
    {
      path: 'globalSearch',
      name: 'instituteSearch',
      component: () => import(/* webpackChunkName: 'thirdparty-search' */ '@/thirdparty/view/globalSearch/index.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    // 资讯详情页(列表+详情)
    {
      path: 'information',
      name: 'instituteInformation',
      component: () => import(/* webpackChunkName: 'thirdparty-information-detail' */ '@/pages/consult'),
      meta: {
        thirdPartyPage: true
      }
    },
    // 资讯详情页(详情)
    {
      path: 'informationDetail',
      name: 'instituteInformationDetail',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-information-detail' */ '@/thirdparty/view/information/detail.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    {
      path: 'summaryAuth',
      name: 'summaryAuth',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-summary-auth' */ '@/thirdparty/view/summary/summaryAuth.vue'),
      meta: {
        thirdPartyPage: true
      }
    },
    //日程列表
    {
      path: 'scheduleList',
      name: 'scheduleList',
      component: () => import(/* webpackChunkName: 'thirdparty-schedule' */ '@/pages/scheduleModule/mine/main.vue'),
      meta: {
        thirdPartyPage: true,
        pageLevel: 1,
        // 页面组件名称 用于缓存
        componentName: 'scheduleListIndex'
      }
    },
    //日程列表- 调研-详情
    {
      path: 'researchDetail',
      name: 'cooperateResearchDetail',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-schedule' */ '@/pages/scheduleManage/mine/researchDetail.vue'),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/scheduleList'
      }
    },
    //日程列表- 策略会-详情
    {
      path: 'strategyDetail/:id',
      name: 'cooperateStrategy',
      component: () => import(/* webpackChunkName: 'thirdparty-schedule' */ '@/pages/research/strategy/detail.vue'),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/scheduleList'
      }
    },
    //日程列表-其他-详情
    {
      path: 'otherMeetingDetail',
      name: 'cooperateOthergDetail',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-schedule' */ '@/pages/scheduleManage/mine/otherThingsMeetDetail.vue'),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/scheduleList'
      }
    },
    //外资研报详情
    {
      path: 'foreignResearch/detail/:id',
      name: 'foreignResearchDetail',
      component: () =>
        import(
          /* webpackChunkName: 'thirdparty-foreign-research' */ '@/pages/reportManage/foreignCapitalReportDetail/index'
        ),
      meta: {
        thirdPartyPage: true,
        parent: '/thirdparty/main'
      }
    },
    {
      // 外资研报 我的解锁
      path: 'foreignMyUnlock',
      name: 'foreignMyUnlock',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-foreign-research' */ '@/pages/reportManage/overseas/myUnlock'),
      meta: { thirdPartyPage: true, parent: '/thirdparty/main' }
    },
    {
      // 外资研报 我的翻译
      path: 'foreignMyTranslate',
      name: 'foreignMyTranslate',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-foreign-research' */ '@/pages/reportManage/overseas/myTranslate'),
      meta: { thirdPartyPage: true, parent: '/thirdparty/main' }
    },
    //AI进宝
    {
      path: 'comeinAichat',
      name: 'comeinAichat',
      redirect: '/thirdparty/comeinAichat/index',
      alias: '/aichat',
      component: () => import(/* webpackChunkName: 'comeinAichat' */ '@/pages/aiAssistant/chatMode/index'),
      meta: {
        title: 'routers.ai_chat_ai_jinbao',
        thirdPartyPage: true
      },
      children: [
        {
          path: 'index',
          name: 'comeinAichatIndex',
          component: () => import(/* webpackChunkName: 'comeinAichat' */ '@/pages/aiAssistant/chatMode/chatHome'),
          // thirdparty 进宝首页同样在路由层恢复上次模式（thirdparty 仅恢复任务模式）
          beforeEnter: beforeEnterOpenChatHome,
          meta: {
            name: 'routers.ai_chat_ai_jinbao',
            pageLevel: 1,
            keepAlive: false,
            hideBreadcrumb: true,
            hideSidebarMenu: true,
            hideAgentModule: true
          }
        },
        {
          path: 'list',
          name: 'comeinAichatList',
          component: () => import(/* webpackChunkName: 'comeinAichat' */ '@/pages/aiAssistant/chatMode/chatList'),
          meta: {
            name: 'routers.ai_chat_ai_jinbao',
            pageLevel: 2,
            parent: '/thirdparty/comeinAichat/index',
            keepAlive: false,
            hideBreadcrumb: true,
            hideSidebarMenu: true,
            hideAgentModule: true
          }
        },
        {
          path: 'history',
          name: 'comeinAichatHistory',
          component: () => import(/* webpackChunkName: 'comeinAichat' */ '@/pages/aiAssistant/chatMode/chatHistory'),
          meta: {
            name: 'routers.ai_chat_ai_jinbao',
            pageLevel: 2,
            parent: '/thirdparty/comeinAichat/index',
            keepAlive: false,
            hideBreadcrumb: true,
            electronSingle: true,
            hideSidebarMenu: true,
            hideAgentModule: true
          }
        },
        {
          path: 'researchBrainManage',
          name: 'comeinAichatResearchBrainManage',
          component: () =>
            import(/* webpackChunkName: 'comeinAichat' */ '@/pages/aiAssistant/chatMode/researchBrainManage'),
          meta: {
            name: 'routers.ai_chat_research_brain_manage',
            pageLevel: 2,
            parent: '/thirdparty/comeinAichat/index',
            keepAlive: false,
            hideBreadcrumb: true,
            electronSingle: true,
            hiddenNav: true,
            hideSidebarMenu: true,
            hideAgentModule: true
          }
        }
      ]
    },
    // 第三方 iframe 嵌入 AI 进宝（独立全屏页，走 thirdPartyPage 鉴权，无进宝侧栏布局）
    {
      path: 'externalAiChatIframe',
      name: 'thirdpartyAiChatExternalIframe',
      component: () =>
        import(
          /* webpackChunkName: 'thirdparty-ai-chat-external-iframe' */ '@/pages/aiAssistant/chatMode/chatExternalIframe.vue'
        ),
      meta: {
        name: 'routers.ai_chat_ai_jinbao',
        pageLevel: 1,
        keepAlive: false,
        hideBreadcrumb: true,
        hideSidebarMenu: true,
        hideAgentModule: true,
        hideOuterBreadcrumb: true,
        hiddenNav: true,
        thirdPartyPage: true
      }
    },
    // AI进宝 · 研究模式
    // 注意：研究模式必须与 comeinAichat 平级（而非作为其子路由），
    // 否则会被 chatMode/index.vue 外层包一层聊天侧边栏，导致页面多出一个会话侧栏。
    // 研究模式自带完整布局（资料库 + 中间编辑器 + 右侧 AI），与任务模式一致独立挂载。
    {
      path: 'comeinAichat/research',
      name: 'thirdpartyAiChatResearch',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-ai-research-mode' */ '@/pages/aiAssistant/researchMode/index'),
      beforeEnter: beforeEnterResearchMode,
      meta: {
        title: 'routers.ai_chat_ai_jinbao',
        name: 'routers.ai_chat_research_mode',
        pageLevel: 2,
        parent: '/thirdparty/comeinAichat/index',
        keepAlive: false,
        hideBreadcrumb: true,
        hideOuterBreadcrumb: true,
        thirdPartyPage: true,
        // 不设置 electronSingle：与任务模式（thirdpartyOpenClawChat）保持一致，
        // 切换到研究模式时复用当前 AI 进宝 tab，而不是新开一个 tab
        hideSidebarMenu: true,
        hideAgentModule: true
      }
    },
    // openClaw
    {
      path: 'openClaw',
      component: () => import(/* webpackChunkName: 'thirdparty-openClaw' */ '@/pages/aiAssistant/taskMode/layout.vue'),
      redirect: '/thirdparty/openClaw/openClawChat',
      meta: {
        title: 'routers.ai_chat_ai_jinbao',
        thirdPartyPage: true
      },
      children: [
        {
          path: 'openClawChat',
          name: 'thirdpartyOpenClawChat',
          component: () =>
            import(/* webpackChunkName: 'thirdparty-openClaw' */ '@/pages/aiAssistant/taskMode/index.vue'),
          meta: {
            thirdPartyPage: true,
            name: 'openClaw.nav.chat',
            parent: '/aiChat/index',
            // 任务模式自带完整布局，不展示内/外层面包屑；与研究模式对齐，
            // 避免从研究模式切入时残留的面包屑（routers.ai_chat_research_mode）显示在任务模式顶部
            hideBreadcrumb: true,
            hideOuterBreadcrumb: true
          }
        },
        {
          path: 'settings',
          name: 'thirdpartyOpenClawSettings',
          redirect: '/thirdparty/openClaw/settings/channels',
          component: () =>
            import(/* webpackChunkName: 'thirdparty-openClaw' */ '@/pages/aiAssistant/taskMode/settings/index.vue'),
          meta: {
            thirdPartyPage: true,
            name: 'openClaw.nav.settings',
            parent: '/aiChat/index'
          },
          children: [
            {
              path: 'channels',
              name: 'thirdpartyOpenClawChannels',
              component: () => import('@/pages/aiAssistant/taskMode/control/channels/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.channels' }
            },
            {
              path: 'sessions',
              name: 'thirdpartyOpenClawSessions',
              component: () => import('@/pages/aiAssistant/taskMode/control/sessions/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.sessions' }
            },
            {
              path: 'heartbeat',
              name: 'thirdpartyOpenClawHeartbeat',
              component: () => import('@/pages/aiAssistant/taskMode/control/heartbeat/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.heartbeat' }
            },
            {
              path: 'mcp',
              name: 'thirdpartyOpenClawMcp',
              component: () => import('@/pages/aiAssistant/taskMode/agent/mcp/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.mcp' }
            },
            {
              path: 'tools',
              name: 'thirdpartyOpenClawTools',
              component: () => import('@/pages/aiAssistant/taskMode/agent/tools/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.tools' }
            },
            {
              path: 'workspace',
              name: 'thirdpartyOpenClawWorkspace',
              component: () => import('@/pages/aiAssistant/taskMode/agent/workspace/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.workspace' }
            },
            {
              path: 'agent-config',
              name: 'thirdpartyOpenClawAgentConfig',
              component: () => import('@/pages/aiAssistant/taskMode/agent/config/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.agentConfig' }
            },
            {
              path: 'models',
              name: 'thirdpartyOpenClawModels',
              component: () => import('@/pages/aiAssistant/taskMode/settings/models/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.models' }
            },
            {
              path: 'environments',
              name: 'thirdpartyOpenClawEnvironments',
              component: () => import('@/pages/aiAssistant/taskMode/settings/environments/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.environments' }
            },
            {
              path: 'agents',
              name: 'thirdpartyOpenClawAgents',
              component: () => import('@/pages/aiAssistant/taskMode/settings/agents/index.vue'),
              meta: { thirdPartyPage: true, name: 'openClaw.nav.agents' }
            },
            {
              path: 'voice-transcription',
              name: 'thirdpartyOpenClawVoiceTranscription',
              component: () => import('@/pages/aiAssistant/taskMode/settings/voiceTranscription/index.vue'),
              meta: {
                name: 'openClaw.nav.voiceTranscription',
                description: 'openClaw.voiceTranscription.description'
              }
            },
            {
              path: 'token-usage',
              name: 'thirdpartyOpenClawTokenUsage',
              component: () => import('@/pages/aiAssistant/taskMode/settings/tokenUsage/index.vue'),
              meta: {
                name: 'openClaw.nav.tokenUsage',
                description: 'openClaw.tokenUsage.description'
              }
            },
            {
              path: 'security',
              name: 'thirdpartyOpenClawSecurity',
              component: () => import('@/pages/aiAssistant/taskMode/settings/security/index.vue'),
              meta: {
                name: 'openClaw.nav.security',
                description: 'openClaw.security.description'
              }
            },
            {
              path: 'skillPool',
              name: 'thirdpartyOpenClawSkillPool',
              component: () => import('@/pages/aiAssistant/taskMode/agent/SkillPool/index.vue'),
              meta: {
                name: 'openClaw.skillPool.pageTitle',
                description: 'openClaw.skillPool.pageDescription'
              }
            }
          ]
        }
      ]
    },
    // iframe 嵌入 - AI 侧边栏（支持通过 URL 固定智能体）
    {
      path: 'agentSidebar',
      name: 'instituteAgentSidebar',
      component: () =>
        import(/* webpackChunkName: 'thirdparty-agent-sidebar' */ '@/thirdparty/view/aiChat/agentSidebar.vue'),
      meta: {
        thirdPartyPage: true,
        keepAlive: false,
        hideBreadcrumb: true,
        electronSingle: true,
        hiddenNav: true,
        hideSidebarMenu: true,
        hideAgentModule: true
      }
    },
    // 404页面
    {
      path: 'instituteNotFound',
      name: 'instituteNotFound',
      component: () => import(/* webpackChunkName: "thirdparty-not-found" */ '@/thirdparty/view/notFound/notFound.vue'),
      meta: {
        thirdPartyPage: true,
        requireAuth: false
      }
    },
    {
      path: '401',
      name: 'notOrg',
      component: () => import(/* webpackChunkName: "thirdparty-not-401" */ '@/thirdparty/view/notFound/notOrg.vue'),
      meta: {
        thirdPartyPage: true,
        requireAuth: false
      }
    },
    {
      path: ':catchAll(.*)',
      redirect: '/thirdparty/instituteNotFound'
    }
  ]
};
